/* global google */
import { Button, Grid, TextField, Typography } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import BackIcon from "@material-ui/icons/KeyboardBackspaceRounded";
import classNames from "classnames";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { translate } from "react-i18next";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import ReactCodeInput from "react-verification-code-input";
import "../../css/login.css";
import InputFormat from "../../partials/inputForm";
import {
  getNumberOnString,
  _parsePhoneNumber,
} from "../../partials/validateNumber";
import { version, _checkRequired } from "../../utils/setting";
import ChangeLanguage from "../changeLanguage";
import CountDownComponent from "../countDown";
import CountryCode from "../countryCode";
import Loading from "../loading";
import Logo from "../logoWithText";
import Snackbar from "../snackbar";
import InputAddress from "../suggestAddress";
import { styles } from "./styles.js";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 1,
      valid: {
        username: {
          invalid: false,
          message: "",
        },
      },
      spa: {
        username: "",
        countryCode: this.props.defaultCountryCode || "+84",
        firstName: "",
        lastName: "",
        address: "",
        activeCode: "",
        website: "",
        phone: "",
        name: "",
      },
      time: 5.99,
      userExisted: false, // Flag kiểm tra sđt đã có tk chưa
      anchorElLanguage: null,
      expiredTime: 0,
    };
    this.sendActiveCode = this.sendActiveCode.bind(this);
  }
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.defaultCountryCode !== this.props.defaultCountryCode &&
      !this.props.defaultCountryCode
    ) {
      let { spa } = this.state;
      spa.countryCode = nextProps.defaultCountryCode;
      this.setState({ spa: spa });
    }
  }
  componentDidMount() {
    const _this = this;

    navigator.geolocation.getCurrentPosition(
      function (position) {
        // success cb
        let location = position.coords;
        var latLng = new google.maps.LatLng(
          location.latitude,
          location.longitude
        );

        var geocoder = new google.maps.Geocoder();
        if (geocoder) {
          geocoder.geocode({ latLng: latLng }, function (results, status) {
            if (
              status === google.maps.GeocoderStatus.OK &&
              results &&
              results[0]
            ) {
              results = results[0];
              let { spa } = _this.state;
              spa.address = results.formatted_address;
              let address_components = results.address_components;
              address_components.forEach((e) => {
                if (
                  e.types.find((e1) => e1 === "administrative_area_level_2")
                ) {
                  spa.district = e.short_name;
                } else if (
                  e.types.find((e1) => e1 === "administrative_area_level_1")
                ) {
                  spa.city = e.short_name;
                } else if (e.types.find((e1) => e1 === "country")) {
                  spa.country = e.short_name;
                } else if (e.types.find((e1) => e1 === "locality")) {
                  spa.state = e.short_name;
                }
              });
              spa.lat = location.latitude;
              spa.lng = location.longitude;
              _this.setState({ spa });
            } else {
              console.log("Geocoding failed: " + status);
            }
          }); //geocoder.geocode()
        }
      },
      function (err) {
        // fail cb
        console.log(err);
      }
    );
  }
  changeStep = (step) => {
    this.setState({ step: step });
  };
  handleChangeAddress = (value) => {
    let { spa } = this.state;
    this.setState({ spa: { ...spa, ...value } });
  };
  handleCountryCode = (name, value) => {
    let spa = this.state.spa;
    spa[name] = value;
    this.setState({ spa });
  };
  handleChangeActiveCode = (value) => {
    let { spa } = this.state;
    spa.activeCode = value;
    this.setState({ spa });
  };
  handleChange = (e) => {
    const { t } = this.props;
    let target = e.target;
    let name = target.name;
    let value =
      name === "username" || name === "phone"
        ? getNumberOnString(target.value)
        : target.value; // Nếu là username thì chỉ lấy chữ số
    let { spa } = this.state;
    spa[name] = value;
    if (name === "username" || name === "countryCode") {
      let validNumber = _parsePhoneNumber(spa.countryCode, spa.username)
        .isValid;
      if (!validNumber) {
        this.setState({
          valid: {
            ...{
              username: {
                invalid: true,
                message: `${spa.countryCode + " " + spa.username} ${t(
                  "is_invalid_phone"
                )}`,
              },
            },
          },
        });
      } else {
        this.setState({
          valid: {
            ...{
              username: {
                invalid: false,
                message: null,
              },
            },
          },
        });
      }
    }
    this.setState({ spa });
  };
  clearValid(valid = {}) {
    valid.firstName = {
      invalid: false,
      message: null,
    };

    valid.lastName = {
      invalid: false,
      message: null,
    };
    valid.username = {
      invalid: false,
      message: null,
    };

    valid.phone = {
      invalid: false,
      message: null,
    };
    valid.name = {
      invalid: false,
      message: null,
    };
    valid.address = {
      invalid: false,
      message: null,
    };
    return valid;
  }
  showMessage(arr = []) {
    const { t } = this.props;
    let valid = {};
    arr.forEach((e) => {
      if (e === "firstName") {
        valid.firstName = {
          invalid: true,
          message: t("pls_enter_first_name"),
        };
      } else if (e === "lastName") {
        valid.lastName = {
          invalid: true,
          message: t("pls_enter_last_name"),
        };
      } else if (e === "username" || e === "countryCode") {
        const { spa } = this.state;
        valid.username = {
          invalid: true,
          message: `${spa.countryCode + " " + spa.username} ${t(
            "is_invalid_phone"
          )}`,
        };
      } else if (e === "name") {
        valid.name = {
          invalid: true,
          message: t("pls_enter_name_spa"),
        };
      } else if (e === "address") {
        valid.address = {
          invalid: true,
          message: t("pls_enter_your_address"),
        };
      } else if (e === "phone") {
        valid.phone = {
          invalid: true,
          message: t("pls_enter_your_phone"),
        };
      } else if (e === "activeCode") {
      }
    });
    return {
      valid,
      flag: Object.keys(valid).length ? true : false,
    };
  }
  handleSubmit = async () => {
    this.loading.startLoading();
    const _this = this;
    const { t } = _this.props;
    let { spa, step } = _this.state;
    let payload = {
      spa,
      snackbar: _this.snackbar,
      t,
    };
    let arr = [];
    if (step === 1) {
      arr = _checkRequired(spa, [
        "username",
        "countryCode",
        "firstName",
        "lastName",
      ]);
    } else if (step === 2) {
      arr = _checkRequired(spa, ["name", "address", "phone"]);
    } else {
      arr = _checkRequired(spa, ["activeCode"]);
    }
    let number = _parsePhoneNumber(spa.countryCode, spa.username).isValid;
    if (!number) arr.push("username");

    let check = _this.showMessage(arr);

    _this.loading.stopLoading();
    if (!check.flag) {
      //true
      if (step === 1) {
        this.loading.startLoading();
        check = await _this.props.checkOwnerSpa(payload);
        this.loading.stopLoading();
        if (check && check.success) {
          _this.setState({
            step: 2,
            userExisted: check.userExisted,
          });
        }
      } else if (step === 2) {
        this.loading.startLoading();
        check = await _this.sendActiveCode();
        this.loading.stopLoading();
        if (check) {
          _this.setState({ step: 3 }, function () {
            _this.countdownStart();
          });
        }
      } else {
        check = await _this.props.checkActiveCode({
          ...spa,
          snackbar: payload.snackbar,
          t,
        });
        if (check && check.code) {
          // if (window.countdown) clearInterval(window.countdown);
          this.loading.startLoading();
          check = await this.props.createServiceForOwner(payload);
          this.loading.stopLoading();
          _this.setState({ time: 6 });
          if (check) {
            _this.setState({ step: 4 });
          }
        }
      }
    } else {
      this.setState({ valid: check.valid });
    }
  };
  handleBack = () => {
    const { step } = this.state;
    this.setState({ step: step - 1 });
  };

  countdownStart = () => {
    if (this.countdown) {
      this.countdown.start();
    }
    return;
  };
  async sendActiveCode() {
    let _this = this;
    this.loading.startLoading();
    let { spa, step } = this.state;
    let check = await this.props.createCodeRegisterForFree({
      spa: spa,
      snackbar: this.snackbar,
    });
    if (check.code === 1) {
      let expiredTime = check.data.expired
        ? Number(check.data.expired) - new Date().getTime()
        : 0;
      this.setState(
        {
          expiredTime: expiredTime,
        },
        function () {
          if (step === 3) _this.countdownStart();
        }
      );
    }
    this.loading.stopLoading();
    return check;
  }
  snackbar = (mess, type = "error") => {
    this.mSnackbar.handleClick(mess, type);
  };

  render() {
    const { t, classes } = this.props;
    const { spa, step, valid, userExisted, expiredTime = 0 } = this.state;
    let number = _parsePhoneNumber(spa.countryCode, spa.username)
      .format_internal;
    return (
      <div className="login-wrapper">
        <Snackbar
          color="white"
          onRef={(snackbar) => (this.mSnackbar = snackbar)}
        />
        <Loading onRef={(id) => (this.loading = id)} />
        <ChangeLanguage />
        <div className="login-container">
          <div
            className={classes.logo}
            onClick={() => this.props.history.push("/")}
          >
            <Logo />
          </div>
          <div className={classes.process}>
            <Grid container spacing={3}>
              <Grid item md={12}>
                <Typography className={classes.titleProcess}>
                  {step === 1
                    ? t("register_your_informations")
                    : step === 2
                    ? t("register_spa_informations")
                    : step === 3
                    ? t("register_verification")
                    : t("register_sign_up_success")}
                </Typography>
              </Grid>
              <Grid container spacing={3}>
                <Grid item xs={4}>
                  <div className={classes.boxStepSuccessful}>
                    <div
                      className={classNames(classes.step, classes.stepActive)}
                    >
                      1
                    </div>
                    <div
                      className={classNames(classes.line, classes.activeLine)}
                    ></div>
                  </div>
                </Grid>
                <Grid item xs={4}>
                  <div className={classes.boxStepSuccessful}>
                    <div
                      className={classNames(
                        classes.step,
                        step > 1 ? classes.stepActive : ""
                      )}
                    >
                      2
                    </div>
                    <div
                      className={classNames(
                        classes.line,
                        step > 1 ? classes.activeLine : ""
                      )}
                    ></div>
                  </div>
                </Grid>
                <Grid item xs={4}>
                  <div className={classes.boxStepSuccessful}>
                    <div
                      className={classNames(
                        classes.step,
                        step > 2 ? classes.stepActive : ""
                      )}
                    >
                      3
                    </div>
                    <div
                      className={classNames(
                        classes.line,
                        step > 2 ? classes.activeLine : ""
                      )}
                    ></div>
                  </div>
                </Grid>
              </Grid>
            </Grid>
          </div>
          <div className={classes.container}>
            {step === 1 ? (
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <Grid container spacing={3} alignItems="center">
                    <Grid item xs={5} sm={5} md={4}>
                      <CountryCode
                        margin="none"
                        code={spa.countryCode}
                        handleCountryCode={this.handleCountryCode}
                      />
                    </Grid>
                    <Grid item xs={7} sm={7} md={8}>
                      <InputFormat
                        required
                        autoComplete="new-username"
                        label={t("login_phone_number")}
                        placeholder={t("login_phone_number")}
                        name={"username"}
                        margin="none"
                        value={spa.username}
                        onChange={this.handleChange}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12} md={12} style={{ padding: 0 }}>
                  {valid.username && valid.username.message ? (
                    <div
                      className={classNames(
                        classes.customValid,
                        `${
                          valid.username && valid.username.invalid
                            ? "invalid"
                            : "valid"
                        }-feedback text-left d-block`
                      )}
                    >
                      {valid.username ? valid.username.message : ""}
                    </div>
                  ) : (
                    <div
                      className={classNames(
                        classes.customInValid,
                        `text-left d-block`
                      )}
                    ></div>
                  )}
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputFormat
                    required
                    autoComplete="new-firstName"
                    label={t("register_first_name")}
                    margin="none"
                    placeholder={t("register_first_name")}
                    name={"firstName"}
                    value={spa.firstName}
                    onChange={this.handleChange}
                  />
                  {valid.firstName && valid.firstName.message ? (
                    <div className={classes.message}>
                      <div
                        className={`${
                          valid.firstName && valid.firstName.invalid
                            ? "invalid"
                            : "valid"
                        }-feedback text-left d-block`}
                      >
                        {valid.firstName ? valid.firstName.message : ""}
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputFormat
                    required
                    autoComplete="new-lastName"
                    margin="none"
                    label={t("register_last_name")}
                    placeholder={t("register_last_name")}
                    name={"lastName"}
                    value={spa.lastName}
                    onChange={this.handleChange}
                  />
                  {valid.lastName && valid.lastName.message ? (
                    <div className={classes.message}>
                      <div
                        className={`${
                          valid.lastName && valid.lastName.invalid
                            ? "invalid"
                            : "valid"
                        }-feedback text-left d-block`}
                      >
                        {valid.lastName ? valid.lastName.message : ""}
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </Grid>
              </Grid>
            ) : step === 2 ? (
              <Grid container spacing={3}>
                <Grid item xs={12}>
                  <InputFormat
                    required
                    label={t("register_spa_name")}
                    placeholder={t("register_spa_name")}
                    name={"name"}
                    autoComplete="new-name"
                    value={spa.name}
                    onChange={this.handleChange}
                  />

                  <div className={classes.message}>
                    <div
                      className={`${
                        valid.name && valid.name.invalid ? "invalid" : "valid"
                      }-feedback text-left d-block`}
                    >
                      {valid.name ? valid.name.message : ""}
                    </div>
                  </div>
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputFormat
                    label={t("register_website")}
                    placeholder={t("register_website")}
                    name={"website"}
                    autoComplete="new-website"
                    value={spa.website}
                    onChange={this.handleChange}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <InputFormat
                    required
                    label={t("register_phone_number")}
                    placeholder={t("register_phone_number")}
                    name={"phone"}
                    autoComplete="new-phone"
                    value={spa.phone}
                    onChange={this.handleChange}
                  />
                  <div className={classes.message}>
                    <div
                      className={`${
                        valid.phone && valid.phone.invalid ? "invalid" : "valid"
                      }-feedback text-left d-block`}
                    >
                      {valid.phone ? valid.phone.message : ""}
                    </div>
                  </div>
                </Grid>
                <Grid item xs={12}>
                  <InputAddress
                    required
                    label={t("register_address")}
                    placeholder={t("register_address")}
                    name="address"
                    margin="none"
                    value={spa.address}
                    handleChange={this.handleChangeAddress}
                    InputProps={{
                      className: classes.input,
                      // endAdornment:
                      //     <InputAdornment position="end">
                      //         <IconButton color="inherit" className={classes.iconButton} aria-label="Directions">
                      //                 <MapIcon />
                      //             </IconButton>
                      //     </InputAdornment>,
                    }}
                    InputLabelProps={{
                      className: classes.label,
                    }}
                  />
                  <div className={classes.message}>
                    <div
                      className={`${
                        valid.address && valid.address.invalid
                          ? "invalid"
                          : "valid"
                      }-feedback text-left d-block`}
                    >
                      {valid.address ? valid.address.message : ""}
                    </div>
                  </div>
                </Grid>
              </Grid>
            ) : step === 3 ? (
              <Grid container spacing={3} justify="center">
                <Grid item xs={12}>
                  <Typography className={classes.infoCode}>
                    {t("register_we_sent_code_to")}
                    <span className={classes.phone}> {number}</span>.
                  </Typography>
                  <Typography className={classes.infoCode}>
                    {t("register_enter_code_below")}.
                  </Typography>
                </Grid>
                <Grid
                  container
                  item
                  xs={12}
                  justify="center"
                  alignItems="center"
                >
                  <TextField style={{ display: "none" }} />
                  <ReactCodeInput
                    onChange={this.handleChangeActiveCode}
                    onComplete={this.handleSubmit}
                    value={spa.activeCode}
                    fieldWidth={60}
                    fieldHeight={54}
                    autoFocus={true}
                  />
                  {valid.activeCode && valid.activeCode.message ? (
                    <div className={classes.message}>
                      <div
                        className={`${
                          valid.activeCode && valid.activeCode.invalid
                            ? "invalid"
                            : "valid"
                        }-feedback text-left d-block`}
                      >
                        {valid.activeCode ? valid.activeCode.message : ""}
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </Grid>
                <Grid item xs={12}>
                  <CountDownComponent
                    onRef={(id) => (this.countdown = id)}
                    expiredTime={expiredTime}
                    resend={this.sendActiveCode}
                    sendDiffentPhone={() => this.changeStep(1)}
                  />
                </Grid>
              </Grid>
            ) : (
              <Grid container spacing={3} justify="center">
                <Grid item xs={12}>
                  {userExisted ? (
                    <Typography className={classes.infoCode}>
                      {t("register_use_previous_password_to_login_admin")}
                    </Typography>
                  ) : (
                    <Typography className={classes.infoCode}>
                      {t("register_use_code_to_login_first_time")}
                    </Typography>
                  )}
                </Grid>
              </Grid>
            )}
            <Grid
              container
              justify="center"
              alignItems="center"
              className={classes.btnBottom}
              spacing={3}
            >
              {step === 1 ? (
                <Grid item xs={12}>
                  <Button
                    variant="contained"
                    size="large"
                    type="submit"
                    fullWidth
                    color="secondary"
                    onClick={this.handleSubmit}
                    className={classes.button}
                  >
                    {t("next")}
                  </Button>
                </Grid>
              ) : step === 4 ? (
                <Link to="/signin">
                  <Button
                    variant="contained"
                    size="large"
                    type="submit"
                    fullWidth
                    color="secondary"
                    className={classes.button}
                  >
                    {t("register_go_to_sign_in")}
                  </Button>
                </Link>
              ) : (
                [
                  <Grid item md={3} key={"row" + Math.random()}>
                    <Button
                      variant="outlined"
                      size="large"
                      type="submit"
                      fullWidth
                      color="secondary"
                      onClick={this.handleBack}
                      className={classes.button}
                    >
                      <BackIcon color="secondary" />
                    </Button>
                  </Grid>,
                  <Grid item md={9} key={"row" + Math.random()}>
                    <Button
                      variant="contained"
                      size="large"
                      type="submit"
                      fullWidth
                      color="secondary"
                      onClick={this.handleSubmit}
                      className={classes.button}
                    >
                      {step === 3 ? t("sign_up") : t("next")}
                    </Button>
                  </Grid>,
                ]
              )}
            </Grid>
            {step <= 3 && (
              <Grid
                container
                spacing={3}
                justify="center"
                alignItems="center"
                style={{ marginTop: 16 }}
              >
                <Link to="/signin">
                  <p className="text-gray">
                    {t("have_an_account")}
                    <span className="text-blue">&nbsp;{t("sign_in")}</span>
                  </p>
                </Link>
              </Grid>
            )}
          </div>
        </div>
        <div className="bottom-version">v {version}</div>
      </div>
    );
  }
}

Login.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapState = (state) => ({
  expired: state.activeCode.expired,
  defaultCountryCode: state.setting.setting
    ? state.setting.setting.defaultCountryCode
    : "+84",
});

const mapDispatch = (dispatch) => ({
  createServiceForOwner: dispatch.user.createServiceForOwner,
  login: dispatch.user.login,
  createForgetPassword: dispatch.activeCode.createForgetPassword,
  checkActiveCode: dispatch.activeCode.checkActiveCode,
  checkOwnerSpa: dispatch.user.checkOwnerSpa,
  createCodeRegisterForFree: dispatch.activeCode.createCodeRegisterForFree,
});
export default connect(
  mapState,
  mapDispatch
)(translate("translations")(withStyles(styles, { withTheme: true })(Login)));
